import { DropDown, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { useTeamMemberFilter } from '@aibees/shared/views/user-management-view/context/team-member-filter-context';
import { useBrowseWorkspaceMembers } from '@aibees/shared/views/user-management-view/hooks/use-browse-workspace-members';
import { memo, useCallback, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SelectMemberProps as Props } from './types';

export const SelectMember = memo(({ className }: Props) => {
  const { browseApi } = useBrowseWorkspaceMembers();
  const { selectedMemberEmail, setSelectedMemberEmail } = useTeamMemberFilter();

  const options = useMemo(() => {
    const members = browseApi.data ?? [];
    const memberOptions = members.map((i) => ({
      key: i?.user?.id ?? `${i?.user?.firstName}-${i?.user?.lastName}`,
      value: i?.user?.username ?? '',
      label: `${i?.user?.firstName ?? ''} ${i?.user?.lastName ?? ''}`,
    }));

    return [
      {
        key: 'all-members',
        value: '',
        label: 'All Team Member',
      },
      ...memberOptions,
    ];
  }, [browseApi.data]);

  const handleChange = useCallback(
    (val: string) => {
      setSelectedMemberEmail(val || undefined);
    },
    [setSelectedMemberEmail]
  );

  return (
    <Styled.Wrapper
      className={classnames('SelectMember', className)}
      sx={SX.root}
    >
      <DropDown
        placeholder="All Team Member"
        options={options}
        value={selectedMemberEmail ?? ''}
        onChange={handleChange}
        startAdornment={
          <Icon
            name="people-group"
            size={24}
            color="grey.400"
            sxx={{ mr: 0.5 }}
          />
        }
      />
    </Styled.Wrapper>
  );
});

SelectMember.displayName = 'SelectMember';
